<template>
    <div :class="classes.box">
        <slot name="header">

        </slot>
        <slot name="title">
            <div class="basket-auth-title">{{ authTitle }}</div>
        </slot>

        <!-- Auth -->
        <div class="form" v-if="!isSendPhone && !isRestorePassword">
            <div class="form-control">
                <div class="form-control-title">{{ phrases.TEXT_USER_PHONE }}</div>
                <input name="phone" class="form-control-input" value="" type="text" placeholder="900-000-00-00" v-model="phone" v-mask="'+7 (###) ###-##-##'">
            </div>
            <div class="form-footer" v-if="!isSetPassword">
                <Captcha></Captcha>
                <div class="button login-button goal-send-phone" :class="{'button-processing': requestWaiting}"
                     @click="confirmPhone">
                  <span v-if="!requestWaiting">{{ phrases.TEXT_BUTTON_APPLY_CODE }}</span>
                  <div v-if="requestWaiting" class="button-loader"></div>
                </div>
            </div>
            <div class="form-footer" v-if="isSetPassword">
                <div class="form-control">
                    <div class="form-control-title">{{ phrases.TEXT_PASSWORD }}</div>
                    <input name="password" class="form-control-input" type="password" value="" v-model="password">
                </div>

                <div class="button login-button goal-personal-login" :class="{'button-processing': requestWaiting}"
                     @click="authorize">
                    <span v-if="!requestWaiting">{{ phrases.TEXT_BUTTON_ENTER }}</span>
                    <div v-if="requestWaiting" class="button-loader"></div>
                </div>
            </div>

            <div class="form-footer-controller">
                <div class="form-control-button form-control-description" v-if="isSetPassword" @click="showRegistrationForm()">
                    {{ phrases.TEXT_BUTTON_REGISTRATION }}
                </div>
                <div class="form-control-button form-control-description" v-if="!isSetPassword" @click="backToAuth">
                  {{phrases.TEXT_AUTHORIZE}}
                </div>
                <div class="form-control-button form-control-description" @click="restorePassword">
                  {{ phrases.TEXT_FORGOT_PASSWORD }}
                </div>
            </div>

            <div class="updates-note" v-if="cityCode === 'vl' || cityCode === 'nhk'">
              <div v-if="lang === 'ru'">
                <div class="updates-note-title">Друзья,
                  <span v-if="cityCode === 'vl'" class="bold">30.01</span><span v-if="cityCode === 'nhk'" class="bold">26.04</span> произошло обновление сайта.</div>
                <div class="updates-note-body" v-if="showUpdatesNote">
                  Для авторизации необходимо пройти повторную Регистрацию: прописать код из смс, пароль и электронную почту.
                  Все <span class="bold">ProstoБонусы</span> успешно сохранены.
                </div>
                <div class="updates-note-close" @click="closeUpdatesNote()">
                  <div v-if="showUpdatesNote">скрыть</div>
                  <div v-else>показать</div>
                </div>
              </div>
              <div v-else>
                <div class="updates-note-title">Friends, <span v-if="cityCode === 'vl'" class="bold">30.01</span><span  v-if="cityCode === 'nhk'" class="bold">30.01</span> the website has been updated.</div>
                <div class="updates-note-body" v-if="showUpdatesNote">
                  To authorize, you need to re-register: register the code from SMS, password and e-mail.
                  All <span class="bold">ProstoBonuses</span> have been successfully saved. You can also get a <span class="bold">20% discount</span> on your first order.
                </div>
                <div class="updates-note-close" @click="closeUpdatesNote()">
                  <div v-if="showUpdatesNote">hide</div>
                  <div v-else>show</div>
                </div>
              </div>
            </div>

            <Agreement/>
            <div class="form-error" v-for="(error, index) in errors" :key="index">{{ error }}</div>
        </div>

        <!-- Registration -->
        <div class="form" v-if="isSendPhone && !isRestorePassword">
            <div class="form-control">
                <div class="form-control-title">{{ phrases.TEXT_SENT_SMS_CODE }}</div>
                <input class="form-control-input" type="text" value="" :placeholder="phrases.TEXT_ENTER_SMS_CODE" v-model="code" v-mask="'####'">
                <div class="form-control-description text-right">
                    <div v-if="smsTimeout === 0" @click="confirmPhone" class="button-link goal-confirm-sms">
                      {{ phrases.TEXT_SEND_SMS_AGAIN }}
                    </div>
                    <div v-if="smsTimeout > 0">{{ [phrases.TEXT_RESEND_SMS_AFTER, smsTimeout].join(' ') }}</div>
                </div>
            </div>

            <div class="form-control">
                <div class="form-control-title">{{phrases.TEXT_ENTER_YOUR_EMAIL}}</div>
                <input name="email" class="form-control-input" type="text" value="" v-model="email">
            </div>

            <div class="form-control">
                <div class="form-control-title">{{phrases.TEXT_SET_PASSWORD_TO_LOGIN}}</div>
                <input class="form-control-input" type="password" value="" v-model="password">
                <div class="form-control-description">{{phrases.TEXT_AT_LEAST_6_CHARACTERS}}</div>
            </div>

            <div class="form-control">
                <div class="form-control-title">{{ phrases.TEXT_PASSWORD_AGAIN }}</div>
                <input class="form-control-input" type="password" value="" v-model="confirm_password">
            </div>

            <div class="button login-button" :class="{'button-processing': requestWaiting}" @click="registration">
              <span v-if="!requestWaiting">{{ phrases.TEXT_BUTTON_APPLY_CODE }}</span>
              <div v-if="requestWaiting" class="button-loader"></div>
            </div>

            <div class="form-error" v-for="(error, index) in errors" :key="index">{{ error }}</div>
        </div>

        <!-- Repair by email-->
        <div class="form" v-if="isRestorePassword && !isRestorePasswordByPhone">
            <div class="form-control">
                <div class="form-control-title">{{phrases.TEXT_ENTER_YOUR_EMAIL}}</div>
                <input name="email" class="form-control-input" type="text" value="" v-model="email">
            </div>
            <div class="form-text" v-if="restorePasswordMessage">{{ restorePasswordMessage }}</div>

            <div v-if="!sentEmailPassword" class="button login-button" :class="{'button-processing': requestWaiting}"
                 @click="restorePasswordByEmail">
                <span v-if="!requestWaiting">{{ phrases.TEXT_RESTORE }}</span>
                <div v-if="requestWaiting" class="button-loader"></div>
            </div>


            <div class="form-footer" v-if="sentEmailPassword">
                <div class="form-control">
                  <div class="form-control-title">{{ phrases.TEXT_PASSWORD }}</div>
                  <input name="password" class="form-control-input" type="password" value="" v-model="password">
                </div>

                <div class="button login-button goal-personal-login" :class="{'button-processing': requestWaiting}"
                     @click="authorize">
                  <span v-if="!requestWaiting">{{ phrases.TEXT_AUTHORIZE }}</span>
                  <div v-if="requestWaiting" class="button-loader"></div>
                </div>
            </div>

            <div class="form-footer-controller">
                <div class="form-control-button form-control-description" @click="setRestorePasswordByPhone">
                  {{phrases.TEXT_RESTORE_PASSWORD_BY_PHONE}}
                </div>
            </div>

            <div class="form-error" v-for="(error,index) in errors" :key="index">{{ error }}</div>
        </div>

        <!-- Repair by sms -->
        <div class="form" v-if="isRestorePassword && isRestorePasswordByPhone">
            <div class="form-control">
                <div class="form-control-title">{{phrases.TEXT_ENTER_YOUR_PHONE}}</div>
                <input name="phone" class="form-control-input" type="text" value="" v-model="phone" placeholder="900-000-00-00" v-mask="'+7 (###) ###-##-##'">
            </div>
            <div class="form-text" v-if="restorePasswordMessage">{{ restorePasswordMessage }}</div>

            <div v-if="!sentSmsPassword">
                <Captcha></Captcha>
                <div class="button login-button" :class="{'button-processing': requestWaiting}" @click="restorePasswordByPhone">
                  <span v-if="!requestWaiting">{{ phrases.TEXT_RESTORE }}</span>
                  <div v-if="requestWaiting" class="button-loader"></div>
                </div>
            </div>

            <div class="form-control-description text-right">
                <div v-if="smsTimeout > 0">{{ [phrases.TEXT_RESEND_SMS_AFTER, smsTimeout].join(' ') }}</div>
            </div>

            <div class="form-footer" v-if="sentSmsPassword">
              <div class="form-control">
                <div class="form-control-title">{{ phrases.TEXT_PASSWORD }}</div>
                <input name="password" class="form-control-input" type="password" value="" v-model="password">
              </div>

              <div class="button login-button goal-personal-login" :class="{'button-processing': requestWaiting}"
                   @click="authorize">
                  <span v-if="!requestWaiting">{{ phrases.TEXT_AUTHORIZE }}</span>
                  <div v-if="requestWaiting" class="button-loader"></div>
              </div>
            </div>

            <div class="form-error" v-for="(error,index) in errors" :key="index">{{ error }}</div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Utils from "../Utils";
    import Agreement from "../partial/auth/agreement";
    import Captcha from "../servies/ReCaptcha_v2";

    export default {
      name: "Auth",
      components: {Agreement, Captcha},
      data: function(){
          return {
              errors: [],
              phone: '',
              code: '',
              email: '',
              password: '',
              confirm_password: '',
              isSendPhone: false,
              isSetPassword: true,
              isRestorePassword: false,
              isRestorePasswordByPhone: false,
              restorePasswordMessage: "",
              formRegistrationError: '',
              smsTimeout: 0,
              smsIntervalId: 0,
              sentEmailPassword: false,
              sentSmsPassword: false,
              requestWaiting: false,
              showUpdatesNote: true,
              showUpdatesNoteCookie: 'show-updates-note',
            };
        },
        props: [
            'classes',
            'showPasswordField'
        ],
        methods:{
            confirmPhone(){
                const component = this;
                component.errors = [];
                const verify = component.isAuthFormVerified();
                if(verify && !component.requestWaiting){
                    component.requestWaiting = true;
                    this.sendRequest('confirm-phone',
                        {phone: this.phone, "captcha-key": component.captcha}).then(response => {
                        const result = response.data;
                        const status = result.status;
                        if (status === 'success'){
                            component.isSetPassword = true;
                        }else if(status === 'wrong-captcha'){
                            component.$store.commit("app/setCaptcha", null);
                            window.grecaptcha.reset();
                        }else if(status === 'no-found'){
                            component.isSendPhone = true;
                        }else if (status === 'error'){
                            if(result.error === "CODE_HAD_BEEN_SENT"){
                                component.sendSmsTimer(result.seconds);
                            }else{
                                component.errors.push(component.errorText(result.error));
                            }
                        }
                    }, () => {
                      component.errors.push(component.phrases['REQUEST_FAILED']);
                    }).finally(() => {
                        component.requestWaiting = false;
                    });
                }
            },
            authorize(){
                const component = this;
                component.restorePasswordMessage = "";
                component.errors = [];
                const verify = component.isAuthFormVerified();
                if(verify && !component.requestWaiting){
                    this.requestWaiting = true;
                    this.sendRequest('authorize', {phone: this.phone, password: this.password,}).then(response => {
                        const result = response.data;
                        const status = result.status;
                        if (status === 'success') {
                            const user = result.user;
                            this.$store.dispatch({
                                type: 'user/setUserInfo',
                                user: user,
                            });
                            this.$store.dispatch({
                                type: 'order/setUserInfo',
                                user: user,
                            });
                            component.updateSessionId(response.headers.session_id);
                        } else {
                          component.errors.push(component.errorText(result.error));
                        }
                    }, () => {
                      component.errors.push(component.errorText('REQUEST_FAILED'));
                    }).finally(() => {
                      component.requestWaiting = false;
                    });
                }
            },
            registration(){
                const component = this;
                this.errors = [];
                const verify = this.isRegistrationFormVerified();
                if(verify){
                    if(!this.requestWaiting) {
                        this.requestWaiting = true;
                        const data = {
                            code: this.code,
                            phone: this.phone,
                            password: this.password,
                            confirm_password: this.confirm_password,
                            email: this.email,
                        };
                        this.sendRequest('registration', data).then(response => {
                            const result = response.data;
                            if (result.status === 'success') {
                                const user = result.user;
                                this.$store.dispatch({
                                    type: 'user/setUserInfo',
                                    user: user,
                                });
                                this.$store.dispatch({
                                    type: 'order/setUserInfo',
                                    user: user,
                                });
                                component.updateSessionId(response.headers.session_id);
                            } else {
                                this.errors.push(this.errorText(result.error));
                            }
                        }, () => {
                          component.errors.push(component.phrases['REQUEST_FAILED']);
                        }).finally(() => {
                            this.requestWaiting = false;
                        });
                    }
                }
            },
            isAuthFormVerified: function () {
                let result = false;
                let phoneValue = this.phone;
                if (phoneValue.length > 0){
                    phoneValue = phoneValue.replace(/\D+/g, '');
                    if (phoneValue.length === 11) {
                        result = true;
                    }
                }
                if(!result){
                    this.errors.push(this.errorText('EMPTY_OR_WRONG_PHONE_FORMAT'));
                }
                if(this.isSetPassword){
                    if(this.password.length < 6){
                        this.errors.push(this.errorText('PASSWORD_HAS_6_SIGN'));
                        result = false;
                    }
                }
                return result;
            },
            isRegistrationFormVerified: function () {
                let result = false;
                if(this.code.length < 4){
                    result = false;
                    this.errors.push(this.errorText('WRONG_CODE_LENGTH_MAX_4'));
                }else if(this.email.length <= 5 || this.email.search("@") < 0){
                    this.errors.push(this.errorText('WRONG_EMAIL_FORMAT'));
                    result = false;
                }else{
                    result = true;
                    if(this.password.length < 6){
                        result = false;
                        this.errors.push(this.errorText('PASSWORD_HAS_6_SIGN'));
                    }else if(this.password !== this.confirm_password){
                        result = false;
                        this.errors.push(this.errorText('WRONG_CONFIRM_PASSWORD'));
                    }
                }

                return result;
            },
            restorePassword: function () {
                this.errors = [];
                this.isRestorePassword = true;
            },
            restorePasswordByEmail: function () {
                const component = this;
                this.errors = [];
                if(this.email.length <= 5 || this.email.search("@") < 0){
                    this.errors.push(this.errorText('WRONG_EMAIL_FORMAT'));
                }else if(!this.requestWaiting) {
                    this.requestWaiting = true;
                    this.sendRequest('restore-password-email', {email: this.email}).then(response => {
                        const result = response.data;
                        if (result.status === 'success') {
                            component.sentEmailPassword = true;
                            this.restorePasswordMessage = this.phrases.CODE_HAS_BEEN_SENT_TO_EMAIL;
                        } else {
                            const errorCode = result.error;
                            this.errors.push(this.errorText(errorCode));
                        }
                    }, () => {
                      component.errors.push(component.phrases['REQUEST_FAILED']);
                    }).finally(() => {
                      this.requestWaiting = false;
                    });
                }
            },
            restorePasswordByPhone: function () {
                const component = this;
                this.errors = [];
                let verify = false;
                let phoneValue = this.phone;
                if (phoneValue.length > 0){
                    phoneValue = phoneValue.replace(/\D+/g, '');
                    if (phoneValue.length === 11) {
                        verify = true;
                    }
                }
                if(!verify){
                    this.errors.push(this.errorText('EMPTY_OR_WRONG_PHONE_FORMAT'));
                }
                if(verify && !this.requestWaiting){
                    this.requestWaiting = true;
                    this.sendRequest('restore-password-phone',
                        {phone: component.phone,  "captcha-key": component.captcha}).then(response => {
                        const result = response.data;
                        if (result.status === 'success') {
                            this.restorePasswordMessage = this.phrases.CODE_HAS_BEEN_SENT_TO_PHONE;
                            this.sentSmsPassword = true;
                        }else if(result.status === 'wrong-captcha'){
                          component.$store.commit("app/setCaptcha", null);
                          window.grecaptcha.reset();
                        } else {
                            const errorCode = result.error;
                            if (errorCode === "CODE_HAD_BEEN_SENT") {
                                this.sendSmsTimer(result.seconds);
                            } else {
                                this.errors.push(this.errorText(errorCode));
                            }
                        }
                    }, () => {
                      component.errors.push(component.phrases['REQUEST_FAILED']);
                    }).finally(() => {
                      this.requestWaiting = false;
                    });
                }
            },
            setRestorePasswordByPhone: function () {
                this.errors = [];
                this.isRestorePasswordByPhone = true;
                this.sentSmsPassword = false;
                this.restorePasswordMessage = "";
            },
            backToAuth: function () {
                this.errors = [];
                this.isRestorePasswordByPhone = false;
                this.isRestorePassword = false;
                this.isSetPassword = true;
            },
            sendSmsTimer: function (seconds) {
                const component = this;
                if(this.smsTimeout === 0) {
                    this.smsTimeout = parseInt(seconds);
                    this.$nextTick(function () {
                        component.smsIntervalId = window.setInterval(() => {
                            if(this.smsTimeout === 0){
                                clearInterval(component.smsIntervalId);
                            }else{
                                this.smsTimeout--;
                            }
                        }, 1000);
                    });
                }
            },
            showRegistrationForm: function (){
              this.isSetPassword = false;
              this.isRegistrationForm = false;
            },
            closeUpdatesNote: function (){
              this.showUpdatesNote = !this.showUpdatesNote;
              this.$cookies.set(this.showUpdatesNoteCookie, this.showUpdatesNote, "6m");
            }
        },
        computed:{
            ...mapGetters('user', {
                userBonuses: 'getBonuses',
                userInfo: 'getInfo',
                isAuthorize: 'isAuthorize',
            }),
            ...mapGetters('app', {
                phrases: 'getPhrases',
                lang: 'getLang',
                captcha: 'getCaptcha'
            }),
            authTitle: function () {
                return !this.isRestorePassword ? this.phrases.TEXT_AUTHORIZE : this.phrases.TEXT_RESTORE_PASSWORD;
            }
        },
        mounted() {
            this.showUpdatesNote = this.$cookies.get(this.showUpdatesNoteCookie) !== undefined && this.$cookies.get(this.showUpdatesNoteCookie) !== "false";
            if(this.$props.showPasswordField){
                this.isSetPassword = true;
            }
        },
        mixins: [Utils],
    }
</script>

<style scoped lang="scss">
  .form-control-button{
    width: 100%;
    padding: 0.25rem 0;
    text-align: center;
    cursor: pointer;
    &:hover{
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
  .form-footer-controller{
    margin: 0.5rem 0;
  }

  .updates-note{
    text-align: center;
    background-color: rgba(255, 255, 255, 0.25);
    padding: 0.25rem;

    &-title{
      margin: 0.25rem 0;
      font-family: "Panton SemiBold", sans-serif;
    }

    &-close{
      cursor: pointer;
      text-decoration: underline;
      text-decoration-style: dashed;
    }

    .bold{
      font-family: "Panton SemiBold", sans-serif;
    }
  }
</style>
